import React from 'react'

const FiltrosBalance = () => {
  return (
    <div className="opciones">
      <div>Filtrar por: </div>
      <select>
        <option value="">Año</option>
        <option value="2022">2021</option>
        <option value="2022">2022</option>
      </select>

      <select>
        <option value="">Mes</option>
        <option value="0">Enero</option>
        <option value="1">Febrero</option>
        <option value="2">Marzo</option>
        <option value="3">Abril</option>
        <option value="4">Mayo</option>
        <option value="5">Junio</option>
        <option value="6">Julio</option>
        <option value="7">Agosto</option>
        <option value="8">Septiembre</option>
        <option value="9">Octubre</option>
        <option value="10">Noviembre</option>
        <option value="11">Diciembre</option>
      </select>

      <select>
        <option value="">Semana</option>
        <option value="1">1-7</option>
        <option value="2">8-14</option>
        <option value="3">15-22</option>
        <option value="4">23-29</option>
        <option value="5">30-31</option>
      </select>

      <select>
        <option value="">Dia</option>
        <option value="0">1</option>
        <option value="1">2</option>
        <option value="2">3</option>
        <option value="3">4</option>
        <option value="4">5</option>
        <option value="5">6</option>
        <option value="6">7</option>
        <option value="7">8</option>
        <option value="8">9</option>
        <option value="9">10</option>
        <option value="10">11</option>
        <option value="11">12</option>
        <option value="12">13</option>
        <option value="13">14</option>
        <option value="14">15</option>
        <option value="15">16</option>
        <option value="16">17</option>
        <option value="17">18</option>
        <option value="18">19</option>
        <option value="19">20</option>
        <option value="20">21</option>
        <option value="21">22</option>
        <option value="22">23</option>
        <option value="23">24</option>
        <option value="24">25</option>
        <option value="25">26</option>
        <option value="26">27</option>
        <option value="27">28</option>
        <option value="28">29</option>
        <option value="29">30</option>
        <option value="30">31</option>
      </select>
    </div>
  )
}

export default FiltrosBalance